import { render, staticRenderFns } from "./veiculosReportModel.vue?vue&type=template&id=5d764000&scoped=true"
import script from "./veiculosReportModel.vue?vue&type=script&lang=js"
export * from "./veiculosReportModel.vue?vue&type=script&lang=js"
import style0 from "./veiculosReportModel.vue?vue&type=style&index=0&id=5d764000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d764000",
  null
  
)

export default component.exports